import { useMemo, useState, useRef, useEffect, useContext } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { callautopopulate } from "../../../services/callautopop";
import { dateHoverRange, getFullMonthSelected } from "../../../utils/Helper";
import { DateObject } from "react-multi-date-picker";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const useInvoice = () => {
  const { showInfo } = useContext(ToastContext);
  const [columnDefs] = useState([
    {
      field: 'user_display_name',
      headerName: 'Employee',
    },
    {
      field: 'employee_id',
      headerName: 'Employee Id',
      width: 120
    },
    {
      field: 'project_name',
      headerName: 'Project',
    },
    {
      field: 'module_name',
      headerName: 'Project Module',
      width: 280,
      cellRenderer: function (params) {
        return (
          <div title={params?.data?.module_name}>{params?.data?.module_name}</div>
        )
      }
    },
    {
      field: 'billable_hours',
      headerName: 'Billable Hours',
      cellStyle: { textAlign: "center" },
      width: 120
    },
    {
      field: 'billable_hours_percentage',
      headerName: 'Billable Hours (%)',
      cellStyle: { textAlign: "center" },
      width: 120
    },
    {
      field: 'non_billable_hours',
      headerName: 'Non Billable Hours',
      cellStyle: { textAlign: "center" },
      width: 120
    },
    {
      field: 'non_billable_hours_percentage',
      headerName: 'Non Billable Hours (%)',
      cellStyle: { textAlign: "center" },
      width: 130
    },
    {
      field: 'project_hours',
      headerName: 'Project Hours',
      cellStyle: { textAlign: "center" },
      width: 120
    },
    {
      field: 'project_hours_percentage',
      headerName: 'Project Hours (%)',
      cellStyle: { textAlign: "center" },
      width: 150
    },
    {
      field: 'total_hours',
      headerName: 'Total',
      cellStyle: { textAlign: "center" },
      width: 120
    },
    {
      field: 'total_project_hours_percentage',
      headerName: 'Total',
      cellStyle: { textAlign: "center" },
      width: 120
    },

  ])
  const [rowDatas, setRowData] = useState([]);
  const tagRef = useRef(null);
  const [filterValues, setfilterValues] = useState({})
  const [isChange, setIsChange] = useState(false);
  const [options, setOptions] = useState({});
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    callautopopulate("users", "project_leads", "business_units", "sub_business_units", "departments").then((res) => {

      setOptions({
        userOption: _.sortBy(res?.users, "user_display_name"),
        leadOption: res?.project_leads,
        unitOption: _.sortBy(res?.business_units, "business_unit"),
        subUnitOption: _.sortBy(res?.sub_business_units, "sub_business_unit"),
        departmentOption: res?.departments
      })
    })
    const dates = getFullMonthSelected();
    const start = new DateObject(dates?.from_date)
    const end = new DateObject(dates?.to_date)
    getCalendar()
    // setfilterValues((prev) => ({ ...prev, hoveredRange: [start, end] }));
  }, []);


  useEffect(() => {
    if (filterValues.hoveredRange?.[0] && filterValues.hoveredRange?.[1] && filterValues.apiCall) {
      getInvoiceSummary()
    }
  }, [filterValues.hoveredRange, filterValues.apiCall]);

  // get invoice calendar
  const getCalendar = async () => {
    try {
      const response = await services.getInvokeRemote('GET', Urls('GETINVOICECALENDAR'))
      if (response?.body?.data?.invoice_Calendar) {
        response?.body?.data?.invoice_Calendar?.forEach((data) => {
          if (data?.is_active == 1) {
            const startdate = data?.startdate?.split("T")?.[0];
            const enddate = data?.end_date?.split("T")?.[0];
            setfilterValues((prev) => ({ ...prev, hoveredRange: [startdate, enddate] }));
          }
        });

      }
    } catch (error) {
      console.error(error);
    }
  }

  // get invoice summary
  const getInvoiceSummary = async (event) => {
    try {

      if (!filterValues?.hoveredRange?.[0] || !filterValues?.hoveredRange?.[1]) {
        showInfo("Info", "Please select invoice date.");
        return;
      }
      setLoader(true)
      const payload = {
        "from_date": typeof filterValues?.hoveredRange[0] === "string" ? filterValues?.hoveredRange[0] : dateHoverRange(filterValues?.hoveredRange[0]),
        "to_date": typeof filterValues?.hoveredRange[1] === "string" ? filterValues?.hoveredRange[1] : dateHoverRange(filterValues?.hoveredRange[1]),
        "project_lead_user_codes": _.pluck(filterValues.project_leads, "user_code").toString(),
        "users": _.pluck(filterValues.users, "user_code").toString(),
        "business_units": _.pluck(filterValues?.business_units, "business_unit").toString(),
        "sub_business_units": _.pluck(filterValues?.sub_business_units, "sub_business_unit").toString(),
        "departments": _.pluck(filterValues?.departments, "attribute_unit_desc").toString()
      }
      const response = await services.getInvokeRemote('POST', Urls('GETINVOICETIMESHEETSUMMARY'), payload);
      if (response?.body?.data?.invoice_Summary) {
        let invoiceSummary = _.filter(response.body.data.invoice_Summary, (data) => data.employee_id !== null && data.user_display_name !== null);
        invoiceSummary = invoiceSummary.sort((a, b) => { return a.user_display_name?.localeCompare(b.user_display_name) || a.project_name?.localeCompare(b.project_name) });
        invoiceSummary?.forEach((data) => {
          data.project_hours = data.project_hours?.toFixed(2);
          data.project_hours_percentage = data.project_hours_percentage?.toFixed(2);
          data.total_hours = data.total_hours?.toFixed(2);
        })
        setRowData(invoiceSummary);
      }
      setIsChange(false)
      setfilterValues((prev) => ({ ...prev, apiCall: false }))
      setLoader(false)
    }
    catch (error) {
      setLoader(false)
      console.error('Error getting invoice summary:', error);
    }

  }

  // to download excel
  const getExcelDownload = async () => {
    if (_.isEmpty(rowDatas)) {
      showInfo("Info", "There is no data to download");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Projects');
    const header = [
      'Employee',
      'Employee Id',
      'Project',
      'Project Module',
      'Billable Hours',
      'Billable Hours (%)',
      "Non Billable Hours",
      "Non Billable Hours (%)",
      'Project Hours',
      'Project Hours (%)',
      'Total'
    ];

    worksheet.addRow(header);
    rowDatas.forEach((rowData) => {
      const row = worksheet.addRow([
        rowData.user_display_name,
        rowData.employee_id,
        rowData.project_name,
        rowData.module_name,
        Number(rowData.billable_hours),
        Number(rowData.billable_hours_percentage),
        Number(rowData.non_billable_hours),
        Number(rowData.non_billable_hours_percentage),
        Number(rowData.project_hours),
        Number(rowData.project_hours_percentage),
        Number(rowData.total_hours)
      ]);

      if (rowData.project_hours_percentage < 100) {
        for (let i = 1; i <= header.length; i++) {
          const cell = row.getCell(i);
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFDDE6F8' }
          };
        }
      }
    });
    const columnWidths = [20, 15, 25, 30, 18, 18, 20, 20, 18, 20, 15];
    worksheet.columns.forEach((col, idx) => {
      col.width = columnWidths[idx];
    });

    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true };
    });

    const start = typeof filterValues?.hoveredRange[0] === "string" ? filterValues?.hoveredRange[0] : dateHoverRange(filterValues?.hoveredRange[0]);
    const end = typeof filterValues?.hoveredRange[1] === "string" ? filterValues?.hoveredRange[1] : dateHoverRange(filterValues?.hoveredRange[1]);
    const fileName = `Invoice_${start}_to_${end}.xlsx`;
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, fileName);
  };


  const handleEvents = (key, value) => {
    if (value === "users") {
      setfilterValues((prev) => ({ ...prev, users: [] }))
    } else if (value === "lead") {
      setfilterValues((prev) => ({ ...prev, lead: [] }))
    } else if (value === "sub_unit") {
      setfilterValues((prev) => ({ ...prev, sub_unit: [] }))
    } else if (value === "business_unit") {
      setfilterValues((prev) => ({ ...prev, business_unit: [] }))
    } else if (value === "department") {
      setfilterValues((prev) => ({ ...prev, department: [] }))
    }
    setIsChange(true)

  }

  return useMemo(() => ({
    tagRef, getInvoiceSummary, getExcelDownload, columnDefs, rowDatas, isChange, setIsChange, filterValues, setfilterValues, handleEvents, options, loader
  }
  ), [tagRef, getInvoiceSummary, getExcelDownload, columnDefs, rowDatas, isChange, setIsChange, filterValues, setfilterValues, handleEvents, options, loader])
}